import React from 'react';

function formatPrice(price) {
  if (price > 0) return `+$${Number.isInteger(price) ? price : price.toFixed(2)}`;
  return 'Free';
}

function GuidedRemovalTypeScreen({
  serviceName,
  addOns = [],
  selectedAddOnIds,
  parentServiceId,
  onSelect,
  onBack,
  onContinue,
}) {
  const selectedSet = selectedAddOnIds || new Set();
  const hasSelection = addOns.some(a => selectedSet.has(a.id));

  return (
    <div className="removal-type-screen">
      <h1 className="removal-type-title">Choose removal type</h1>
      {serviceName && <p className="removal-type-sub">For your {serviceName}</p>}

      <div className="removal-type-list">
        {addOns.map(addOn => {
          const isSelected = selectedSet.has(addOn.id);
          return (
            <button
              key={addOn.id}
              type="button"
              className={`removal-type-card ${isSelected ? 'selected' : ''}`}
              onClick={() => onSelect(addOn, parentServiceId)}
              aria-pressed={isSelected}
            >
              <span className="removal-type-info">
                <span className="removal-type-name">{addOn.name}</span>
                {addOn.duration > 0 && (
                  <span className="removal-type-meta">+{addOn.duration} min</span>
                )}
              </span>
              <span className="removal-type-price">{formatPrice(addOn.price)}</span>
              <span className={`removal-type-check ${isSelected ? 'checked' : ''}`}>
                {isSelected ? '✓' : ''}
              </span>
            </button>
          );
        })}
      </div>

      <div className="removal-type-bottom">
        {onBack && (
          <button type="button" className="removal-type-back" onClick={onBack}>← Back</button>
        )}
        {onContinue && (
          <button
            type="button"
            className="removal-type-continue"
            onClick={onContinue}
            disabled={!hasSelection}
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}

export default GuidedRemovalTypeScreen;
